<template>
  <div class="app-container">
    <BjDivider>
      <!-- {{ $t('BusinessPurchaseDetailPage.order') }} -->
      {{ $t('BusinessPurchaseDetailPage.Basic') }}
      <template #right>
        <el-button v-if="data.source === 'SYSTEM'" type="primary" @click="showLog">{{ $t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>
    <!-- <div class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <span class="bj-form-title">
          {{ $t('BusinessPurchaseDetailPage.order') }}: <span class="red">{{ data.statusMeaning }}</span>
        </span>
        <span class="bj-form-title" style="margin-left:20px">
          {{ $t('BusinessPurchaseDetailPage.Receipt') }}: <span class="red">{{ data.stockinStatusMeaning }}</span>
        </span>
        <div class="flex-center">
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseDetailPage.quantity') }}</p>
            <span>{{ data.planQty || 0 }}</span>
          </div>
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseDetailPage.Received') }}</p>
            <span>{{ data.alreadyQty || 0 }}</span>
          </div>
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseDetailPage.Not') }}</p>
            <span>{{ data.waitQty || 0 }}</span>
          </div>
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseDetailPage.Data') }}</p>
            <span>{{ data.dataFaultToleranceQty || 0 }}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="bj-row mt20">
      <!-- 模块一 -->
      <div class="bj-col-12">
        <template>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.number') }}</div>
            <div class="bj-form-item-value">{{ data.code }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.requisi') }}</div>
            <div class="bj-form-item-value">{{ data.applyCode }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrderList.contract') }}</div>
            <div class="bj-form-item-value">{{ data.thirdCode }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">来源</div>
            <div class="bj-form-item-value">{{ data.source }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">出运国家</div>
            <div class="bj-form-item-value">{{ data.countryCode }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.type') }}</div>
            <div class="bj-form-item-value">{{ data.typeMeaning }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.Receiving') }}</div>
            <div class="bj-form-item-value">{{ data.warehouseName }}</div>
          </div>
        </template>
      </div>
      <!-- 模块三 -->
      <div class="bj-col-12">
        <template>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.Buyer') }}</div>
            <div class="bj-form-item-value">{{ data.buyerName }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.Creation') }}</div>
            <div class="bj-form-item-value">{{ data.creationDate }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrderList.table.Generation') }}</div>
            <div class="bj-form-item-value">{{ data.documentDate }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.Approval') }}</div>
            <div class="bj-form-item-value">{{ data.auditTime }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.Completion') }}</div>
            <div class="bj-form-item-value">{{ data.finishTime }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseDetailPage.Remarks') }}</div>
            <div class="bj-form-item-value">{{ data.remark }}</div>
          </div>
        </template>
      </div>
    </div>
    <BjDivider>{{ $t('BusinessPurchaseDetailPage.info') }}</BjDivider>
    <div class="bj-row">
      <el-col :span="24" style="padding-top: 10px;">
        <BjStatusTabs :option-list="TAB_LIST" :value="auditTabsValue" @handleTabClick="handleTabClick" />
      </el-col>
      <el-col :span="24" style="padding: 0 20px;">
        <div v-if="auditTabsValue === 'tab1'" class="flex">
          <span></span>
          <RightToolbar @showSetting="toolbarShow" />
        </div>
        <el-table v-show="auditTabsValue === 'tab1' && tableShow" :data="data.goodsList" border script max-height="600">
          <el-table-column :label="$t('table.countText')" type="index" width="65" fixed="left" align="center" />
          <el-table-column v-if="sortableSetting.skuCode" label="SKU" prop="skuCode" fixed="left" align="center" width="133" />
          <el-table-column v-if="sortableSetting.planQty" :label="$t('BusinessPurchaseDetailPage.table.Purchase')" prop="planQty" align="center" width="88" />
          <!-- <el-table-column :label="$t('BusinessPurchaseDetailPage.table.Quantity')" prop="inProdQty" align="center" width="110" />
          <el-table-column :label="$t('BusinessPurchaseDetailPage.table.transit')" prop="inTransitQty" align="center" width="82" />
          <el-table-column :label="$t('BusinessPurchaseDetailPage.table.not')" prop="waitQty" align="center" width="104" />
          <el-table-column :label="$t('BusinessPurchaseDetailPage.table.Received')" prop="alreadyQty" align="center" width="90" /> -->
          <el-table-column v-if="sortableSetting.cnPurchasePrice" :label="$t('BusinessPurchaseApply.cnPurchasePrice')" prop="cnPurchasePrice" align="center" width="113" />
          <el-table-column v-if="sortableSetting.auPurchasePrice" :label="$t('BusinessPurchaseApply.foreignPurchasePrice')" prop="auPurchasePrice" align="center" width="135" />
          <el-table-column v-if="sortableSetting.price" :label="$t('BusinessPurchaseDetailPage.table.Selling')" prop="price" align="center" width="100" />
          <el-table-column v-if="sortableSetting.linkUrl" :label="$t('BusinessPurchaseDetailPage.table.Link')" prop="linkUrl" align="center" width="162">
            <template v-slot="{ row }">
              <a :href="'https://'+row.linkUrl" target="_blank">{{ row.linkUrl }}</a>
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.linkMinPrice" :label="$t('BusinessPurchaseDetailPage.table.Price')" prop="linkMinPrice" align="center" width="108" />
          <el-table-column v-if="sortableSetting.expressPrice" :label="$t('BusinessPurchaseDetailPage.table.Express')" prop="expressPrice" align="center" width="110" />
          <el-table-column v-if="sortableSetting.consumptionTax" :label="$t('BusinessPurchaseDetailPage.table.Consumption')" prop="consumptionTax" align="center" width="132" />
          <el-table-column v-if="data.type!=='COMMON'" :label="$t('BusinessPurchaseDetailPage.table.Platform')" prop="platformPrice" align="center" width="107" />
          <el-table-column v-if="sortableSetting.resendRefundRate" label="refund & resend rate" prop="resendRefundRate" align="center" width="149">
            <template v-slot="{ row }">
              {{ row.resendRefundRate | profitMarginFilter }}
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.estimatedProfit" :label="$t('BusinessPurchaseDetailPage.table.Estimated')" prop="estimatedProfit" align="center" width="121" />
          <el-table-column v-if="sortableSetting.estimatedProfitRate" :label="$t('BusinessPurchaseDetailPage.table.Expected')" prop="estimatedProfitRate" align="center" width="131">
            <template v-slot="{ row }">
              {{ row.estimatedProfitRate }}%
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.actualProfitRate" :label="$t('BusinessPurchaseDetailPage.table.Actual')" prop="actualProfitRate" align="center" width="106">
            <template v-slot="{ row }">
              {{ row.actualProfitRate | profitMarginFilter }}
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.purchaseRiskLevel" :label="$t('BusinessPurchaseDetailPage.table.risk')" prop="purchaseRiskLevel" align="center" width="117">
            <template v-slot="{ row }">
              <div v-if="row.purchaseRiskLevel">
                <span v-if="row.purchaseRiskLevel === '1'" class="dot red_dto"></span>
                <span v-else-if="row.purchaseRiskLevel === '2'" class="dot yellow"></span>
                <span v-else class="dot green"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" prop="barCode" align="center" width="118" />
          <el-table-column :label="$t('BusinessPurchaseDetailPage.table.cartonBoxBarcode')" prop="cartonBoxBarcode" align="center" width="160" />
          <el-table-column v-if="sortableSetting.brandName" :label="$t('BusinessPurchaseDetailPage.table.brand')" prop="brandName" align="center" width="113" />
          <el-table-column v-if="sortableSetting.categoryName" :label="$t('BusinessPurchaseDetailPage.table.Product1')" prop="categoryName" align="center" width="143" />
          <!-- <el-table-column :label="$t('BusinessPurchaseDetailPage.table.Product2')" prop="categoryName" align="center" width="142" /> -->
          <el-table-column v-if="sortableSetting.skuName" :label="$t('BusinessPurchaseDetailPage.table.Description')" prop="skuName" align="center" width="146" />
          <el-table-column v-if="sortableSetting.length" :label="$t('BusinessPurchaseDetailPage.table.length')" prop="length" align="center" width="118" />
          <el-table-column v-if="sortableSetting.width" :label="$t('BusinessPurchaseDetailPage.table.width')" prop="width" align="center" width="113" />
          <el-table-column v-if="sortableSetting.height" :label="$t('BusinessPurchaseDetailPage.table.high')" prop="height" align="center" width="117" />
          <el-table-column v-if="sortableSetting.volume" :label="$t('BusinessPurchaseDetailPage.table.Volume')" prop="volume" align="center" width="133">
            <template v-slot="{ row }">
              {{ isNaN(row.width * row.height * row.length / 1000000) ? '' : (row.width * row.height * row.length / 1000000) }} m³
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.weight" :label="$t('BusinessPurchaseDetailPage.table.Weight')" prop="weight" align="center" width="118" />
          <el-table-column v-if="sortableSetting.cartonLength" :label="$t('BusinessPurchaseDetailPage.table.boxLength')" prop="cartonLength" align="center" width="101">
            <template v-slot="{ row }">
              {{ row.cartonLength }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonWidth" :label="$t('BusinessPurchaseDetailPage.table.boxWidth')" prop="cartonWidth" align="center" width="92">
            <template v-slot="{ row }">
              {{ row.cartonWidth }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonHeight" :label="$t('BusinessPurchaseDetailPage.table.boxheight')" prop="cartonHeight" align="center" width="91">
            <template v-slot="{ row }">
              {{ row.cartonHeight }} cm
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonVolume" :label="$t('BusinessPurchaseDetailPage.table.boxVolume')" prop="cartonVolume" align="center" width="104">
            <template v-slot="{ row }">
              {{ isNaN(row.cartonLength * row.cartonWidth * row.cartonHeight / 1000000) ? '' : (row.cartonLength * row.cartonWidth * row.cartonHeight / 1000000) }} m³
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.cartonWeight" :label="$t('BusinessPurchaseDetailPage.table.boxWeight')" prop="cartonWeight" align="center" width="93">
            <template v-slot="{ row }">
              {{ row.cartonWeight }} kg
            </template>
          </el-table-column>
          <el-table-column v-if="sortableSetting.qty" :label="$t('BusinessPurchaseDetailPage.table.per')" prop="qty" align="center" width="106" />
          <el-table-column v-if="sortableSetting.createdName" :label="$t('BusinessPurchaseDetailPage.table.Buyer')" prop="createdName" align="center" width="133" />
        </el-table>
        <div v-if="auditTabsValue==='tab1'" class="mt20 mb20 flex flex-spacebetween">
          <span></span>
          <div class="font16" style="color: #3d3d3d">
            <span class="mr20">{{ $t('BusinessPurchaseDetailPage.plantQtySum') }}：<span class="font18">{{ planQtyTotal || 0 }}</span></span>
            <span class="mr20">{{ $t('BusinessPurchaseDetailPage.productVolume') }}：<span class="font18">{{ volumeTotal }} m³</span></span>
            <span>{{ $t('BusinessPurchaseDetailPage.cartonWeight') }}：<span class="font18">{{ weightTotal }} kg</span></span>
          </div>
        </div>
        <el-table v-show="auditTabsValue === 'tab2'" :data="data.goodsLinkList" border script max-height="600">
            <el-table-column :label="$t('table.countText')" type="index" width="65" align="center" />
            <el-table-column :label="$t('BusinessPurchaseDetailPage.contractNo')" prop="contractNo" align="center" />
            <el-table-column label="SKU" prop="skuCode" align="center" />
            <el-table-column :label="$t('BusinessPurchaseDetailPage.planQty')" prop="planQty" align="center" width="145" />
            <el-table-column :label="$t('BusinessPurchaseForecast.schedulingQty')" prop="schedulingQty" align="center" />
            <el-table-column :label="$t('BusinessPurchaseForecast.shippingQty')" prop="shippingQty" align="center" />
            <el-table-column :label="$t('BusinessPurchaseForecast.shipmentQty')" prop="shipmentQty" align="center" />
            <el-table-column :label="$t('ChannelManagement.Header.currency')" prop="currency" align="center" />
            <el-table-column :label="$t('BusinessPurchaseComponentsPur.table.UnitPrice')" prop="unitPrice" align="center" />
            <el-table-column :label="$t('BusinessPurchaseComponentsPur.table.GrossAmount')" prop="totalPrice" align="center" />
            <el-table-column :label="$t('BusinessPurchaseDetailPage.signDate')" prop="signDate" align="center" />
            <el-table-column :label="$t('BusinessPurchaseDetailPage.execStatus')" prop="execStatus" align="center">
              <template v-slot="{ row }">
                <el-tag :type="row['execStatus'] === '1' ? 'info' : 'success'">{{ $t(EXEC_STATUS_LIST.bjGet(row['execStatus'])) }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
      </el-col>
    </div>
    <BjDivider>{{ $t('BusinessPurchaseDetailPage.Associated') }}</BjDivider>
    <el-table :data="data.associatedList" border script max-height="600">
      <el-table-column :label="$t('table.countText')" type="index" width="65" align="center" />
      <el-table-column :label="$t('BusinessPurchaseDetailPage.dataForm.type')" prop="typeMeaning" align="center" />
      <el-table-column :label="$t('BusinessPurchaseDetailPage.dataForm.number')" prop="associatedCode" align="center" />
      <el-table-column :label="$t('BusinessPurchaseDetailPage.dataForm.status')" prop="associatedStatusMeaning" align="center" />
      <el-table-column :label="$t('BusinessPurchaseDetailPage.dataForm.time')" prop="creationDate" align="center" />
      <el-table-column :label="$t('BusinessPurchaseDetailPage.dataForm.by')" prop="createdName" align="center" />
    </el-table>
    <!--    表格setting-->
    <ElementTableSortable ref="ElementTableSortable" :page-type="sortableSettingPage" :sortable-setting="sortableSetting" @settingTableTitle="settingTableTitle" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { EXEC_STATUS_LIST } from '@/utils/constants';
import { purchaseApi } from '@/api';
import orderLog from '@/utils/log.js';
import RightToolbar from '../components/RightToolbar';
import ElementTableSortable from '../components/PurchaseTableSortable';
export default {
  name: 'BusinessPurchaseDetail',
  components: { ElementTableSortable, RightToolbar },
  mixins: [viewMiXin],
  data() {
    return {
      EXEC_STATUS_LIST,
      isStatus: this.$route.query.status,
      data: {},
      auditTabsValue: 'tab1',
      TAB_LIST: [
        {
          label: this.$t('BusinessPurchaseDetailPage.tab1'),
          value: 'tab1'
        },
        {
          label: this.$t('BusinessPurchaseDetailPage.tab2'),
          value: 'tab2'
        }
      ],
      sortableSetting: {
        skuCode: true,
        planQty: true,
        cnPurchasePrice: true,
        auPurchasePrice: true,
        price: true,
        linkUrl: true,
        linkMinPrice: true,
        expressPrice: true,
        consumptionTax: true,
        resendRefundRate: true,
        estimatedProfit: true,
        estimatedProfitRate: true,
        actualProfitRate: true,
        purchaseRiskLevel: true,
        barCode: true,
        brandName: true,
        categoryName: true,
        skuName: true,
        length: true,
        width: true,
        height: true,
        volume: true,
        weight: true,
        cartonLength: true,
        cartonWidth: true,
        cartonHeight: true,
        cartonVolume: true,
        cartonWeight: true,
        qty: true,
        createdName: true
      },
      sortableSettingPage: 'PurchaseDetail',
      tableShow: true
    };
  },
  computed: {
    weightTotal() {
      if (!this.data?.goodsList?.length) return 0;
      return this.data.goodsList.reduce((pre, cur) => (pre += cur.cartonWeight), 0);
    },
    volumeTotal() {
      if (!this.data?.goodsList?.length) return 0;
      const volumeTotal = this.data.goodsList.reduce((pre, cur) => {
        const number = Math.ceil(cur.planQty / cur.qty);
        // eslint-disable-next-line no-return-assign
        return pre += (number * (cur.length * cur.width * cur.height));
      }, 0);
      return (volumeTotal / 1000000).toFixed(6);
    },
    planQtyTotal() {
      if (!this.data?.goodsList?.length) return 0;
      return this.data.goodsList.reduce((pre, cur) => (pre += cur.planQty), 0);
    },
  },
  watch: {},
  created() {
    if (localStorage.getItem('PurchaseDetailTitleSetting')) {
      this.sortableSetting = JSON.parse(localStorage.getItem('PurchaseDetailTitleSetting'));
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    settingTableTitle(value) {
      localStorage.setItem('PurchaseDetailTitleSetting', JSON.stringify(value));
      this.tableShow = false;
      this.sortableSetting = value;
      setTimeout(() => (this.tableShow = true), 500);
    },
    toolbarShow() {
      this.$nextTick(() => {
        this.$refs.ElementTableSortable.show();
      });
    },
    handleTabClick(value) {
      if (value.name === 'tab1') {
        this.auditTabsValue = 'tab1';
      } else {
        this.auditTabsValue = 'tab2';
      }
    },
    // 返回按钮
    handleClose() {
      this.cancel();
    },
    // 查看操作日志
    async showLog() {
      const res = await purchaseApi['getApplysDetail']({code: this.data.applyCode});
      const id = res.id;
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText1')} ${this.data.applyCode} ${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
          defaultQuery: {
            recordId: id,
            recordType: 'APPLY',
          },
          search: [],
        }),
      );
    },
    // 获取详情页数据
    getData() {
      purchaseApi['getPurchasesDetail']({
        id: this.$route.query.id,
        code: this.$route.query.code,
      }).then(async res => {
          const skuCode = res.goodsList.map(item => item.skuCode);
          const skuList = await purchaseApi.purchaseGoodsImport(skuCode);
        // eslint-disable-next-line no-return-assign
          if (!skuList.length) return this.data = res;
          const goodsList = [];
          skuList.forEach(v1 => {
          res.goodsList.forEach(v2 => {
            if (v2.skuCode === v1.skuCode) {
              if (!v1.cartonHeight || !v1.cartonLength || !v1.cartonWidth) {
                goodsList.push(
                  { ...v1,
                    ...v2,
                    cartonHeight: v1.height,
                    cartonLength: v1.length,
                    cartonWidth: v1.width,
                    cartonWeight: v1.cartonWeight || 0,
                    qty: v1.qty || 1,
                    createdName: res.buyerName,
                    categoryName: v1.categoryStr
                  });
              } else {
                goodsList.push(
                  { ...v1,
                    ...v2,
                    qty: v1.qty || 1,
                    cartonWeight: v1.cartonWeight || 0,
                    createdName: res.buyerName,
                    categoryName: v1.categoryStr
                  });
              }
            }
          });
        });
        this.data = res;
        this.data.goodsList = goodsList;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.font18 {
  font-size: 18px;
}
.flex-center {
  justify-content: left;
}
.numBox {
  position: relative;
  flex: 0 0 160px;
  padding-bottom: 15px;
}
.numBox p {
  font-size: 12px;
}
.numBox::after {
  position: absolute;
  content: '';
  height: 5px;
  bottom: 0;
  left: 15px;
  right: 15px;
  display: block;
}
.numBox:nth-child(1):after {
  background-color: $pink;
}
.numBox:nth-child(2):after {
  background-color: $green;
}
.numBox:nth-child(3):after {
  background-color: $sub-dark;
}
.numBox:nth-child(4):after {
  background-color: yellowgreen;
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.red_dto {
  background-color: red;
}

.yellow {
  background-color: yellow;
}

.green {
  background-color: green;
}
</style>
